/*
 * @Author: your name
 * @Date: 2021-02-22 16:43:26
 * @LastEditTime: 2021-02-23 09:00:07
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \云平台\src\router\home.js
 */
import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/views/layout/index'

Vue.use(Router)
const homeRouter =[
  {
    path: '',
    component: Layout,
    redirect:'index',
    name:'home',
    linkActiveClass:'active',
    children: [
    {
      path: 'index',
      component: () => import('@/views/home/index'),//首页      
      name: 'index',
      linkActiveClass:'active'
    },
    {
      path: '/home-sycp',
      component: () => import('@/views/home/home-sycp'),//试用产品
      name: 'home-sycp',
      linkActiveClass:'active'
    },
    {
      path: '/product-zyjkqy',
      component: () => import('@/views/product/product-zyjkqy'),//产品中心-职业健康企业
      name: 'product-zyjkqy',
      linkActiveClass:'active'
    },
    {
      path: '/product-tpzs',
      component: () => import('@/views/product/product-tpzs'),//产品中心-共享系统
      name: 'product-tpzs',
      linkActiveClass:'active'
    },
    {
      path: '/product-fswsjg',
      component: () => import('@/views/product/product-fswsjg'),//产品中心-放射卫生监管
      name: 'product-fswsjg',
      linkActiveClass:'active'
    },
    {
      path: '/product-fsyy',
      component: () => import('@/views/product/product-fsyy'),//产品中心-放射医院
      name: 'product-fsyy',
      linkActiveClass:'active'
    },
    {
      path: '/product-zyjkjt',
      component: () => import('@/views/product/product-zyjkjt'),//产品中心-职业健康集团
      name: 'product-zyjkjt',
      linkActiveClass:'active'
    },
    {
      path: '/product-zyjkjg',
      component: () => import('@/views/product/product-zyjkjg'),//产品中心-职业健康监管
      name: 'product-zyjkjg',
      linkActiveClass:'active'
    },
    {
      path: '/product-jkgw',
      component: () => import('@/views/product/product-jkgw'),//产品中心-健康顾问
      name: 'product-jkgw',
      linkActiveClass:'active'
    }
    ]
  }
]

export default homeRouter



// WEBPACK FOOTER //
// ./src/router/home.js